import { isCarriersModuleEnabled } from '@/common/carrierAssignment'
const ToursListExtras = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListExtras')
const ToursListItemId = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemId')
const ToursListItemLabel = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemLabel')
const ToursListItemOptimized = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemOptimized')
const ToursListItemCourier = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemCourier')
const ToursListItemCarrier = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemCarrier')
const ToursListItemStatus = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemStatus')
const ToursListItemStops = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemStops')
const ToursListItemComment = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListItemComment')
const ToursListActions = () => import(/* webpackChunkName: "tours" */ '@/components/Tours/ListActions')

const toursModel = vm => ({
  title: vm.$gettext('Tours'),
  endpoint: 'tours',
  allowNew: false,
  countrize: 'country_iso_code',
  allowSelect: true,
  listExtrasComponent: ToursListExtras,
  fields: [
    {
      key: 'id',
      sortable: true,
      component: (value, key, item) => ({
        is: ToursListItemId,
        props: { value, item }
      })
    },
    {
      key: 'label',
      label: vm.$gettext('Label'),
      sortable: true,
      component: (value, key, item) => ({
        is: ToursListItemLabel,
        props: { value, item }
      })
    },
    {
      key: 'optimized',
      label: vm.$gettext('Opt.'),
      sortable: false,
      component: (value, key, item) => ({
        is: ToursListItemOptimized,
        props: { item }
      })
    },
    {
      key: 'courier_id',
      sortable: true,
      editable: true,
      label: vm.$gettext('Courier'),
      component: (value, key, item) => ({
        is: ToursListItemCourier,
        props: { item }
      })
    },
    // Only for ecosystems with the carriers module (MOOV-5506)
    ...(isCarriersModuleEnabled()
      ? [
          {
            // Read only: PATCH /tours ignores it, it goes through tours/{id}/courier-company
            key: 'courier_company_id',
            sortable: true,
            editable: false,
            label: vm.$gettext('Carrier'),
            component: (value, key, item) => ({
              is: ToursListItemCarrier,
              props: { item }
            })
          }
        ]
      : []),
    {
      key: 'status',
      label: vm.$gettext('Status'),
      sortable: true,
      editable: true,
      component: (value, key, item) => ({
        is: ToursListItemStatus,
        props: { item }
      })
    },
    {
      key: 'stops',
      sortable: false,
      editable: false,
      label: vm.$gettext('Visits'),
      component: (value, key, item) => ({
        is: ToursListItemStops,
        props: { item }
      })
    },
    {
      key: 'comment',
      label: vm.$gettext('Ref./Comments'),
      sortable: false,
      editable: false,
      component: (value, key, item) => ({
        is: ToursListItemComment,
        props: { value, item }
      })
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: true,
      editable: false
    },
    {
      key: 'updated_at',
      label: vm.$gettext('Updated At'),
      sortable: true,
      editable: false
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: ToursListActions,
        props: { row }
      })
    }
  ],
  filters: ['id', 'label', 'courier_id', 'status', 'created_at'],
  includes: [
    'shippings',
    'visits',
    'courier.courier_available.tracking',
    'fixed_amount_price_schedules.fixed_tour',
    'courier_company'
  ]
})

export default toursModel
